import React, { useState } from 'react';
import { LegalPage } from '../components/legal/LegalPage';
import { privacyPolicy } from '../data/legal/privacyPolicy';
import { detectLang } from '../utils/lang';
export function PrivacyPolicyPage() {
  const [lang] = useState(detectLang);
  return <LegalPage doc={privacyPolicy[lang]} lang={lang} data-id="element-1206" data-mp="qcwe851lmuuc" />;
}